import React from 'react'
import { ICommissionRule } from '../../core/response.types'
import { DIRECTION_LABELS, KIND_LABELS, formatRuleBps } from '../../core/consts'
import { convertUTCtoMSK } from '../../../../../../../utils'

interface Props {
  rule:     ICommissionRule
  onEdit:   (rule: ICommissionRule) => void
  onDelete: (rule: ICommissionRule) => void
  onAudit:  (rule: ICommissionRule) => void
}

const scopeText = (r: ICommissionRule): string => {
  if (r.merchantToken) return `Мерчант: ${r.merchantTitle ?? r.merchantToken}`
  if (r.cashBoxId)    return `Касса: ${r.cashBoxTitle ?? '#' + r.cashBoxId}`
  if (r.cashboxKind)  return `Тип кассы: ${KIND_LABELS[r.cashboxKind]}`
  return 'Все'
}

const CommissionRulesRow: React.FC<Props> = ({ rule, onEdit, onDelete, onAudit }) => {
  const locked = rule.immutable || rule.isDefault
  return (
    <tr>
      <td>{DIRECTION_LABELS[rule.direction]}</td>
      <td>{rule.currency}</td>
      <td>{scopeText(rule)}</td>
      <td>{rule.paymentMethod ?? '—'}</td>
      <td style={{ whiteSpace: 'nowrap' }}>
        <span className={rule.feeKind === 'REBATE' ? 'text-danger fw-bold' : ''}>
          {formatRuleBps(rule.bps, rule.feeKind)}
        </span>
        {rule.feeKind === 'REBATE' && (
          <span className='badge badge-light-danger ms-2'>Ребейт</span>
        )}
      </td>
      <td>{rule.fixed}</td>
      <td>
        {rule.minFee ?? '—'} / {rule.maxFee ?? '—'}
      </td>
      <td>
        {rule.amountMin ?? '—'} – {rule.amountMax ?? '—'}
      </td>
      <td>
        {rule.isDefault && <span className='badge badge-light-primary me-1'>Системное</span>}
        {rule.immutable && <span className='badge badge-light-warning me-1'>Только чтение</span>}
        {!rule.isDefault && <span className='badge badge-light-success me-1'>Пользовательское</span>}
      </td>
      <td style={{ whiteSpace: 'nowrap' }}>{rule.createdAt ? convertUTCtoMSK(rule.createdAt) : '—'}</td>
      <td style={{ whiteSpace: 'nowrap' }}>{rule.updatedAt ? convertUTCtoMSK(rule.updatedAt) : '—'}</td>
      <td className='text-end'>
        <button type='button' className='btn btn-sm btn-light me-2' onClick={() => onEdit(rule)}>
          {locked ? 'Просмотр' : 'Изменить'}
        </button>
        <button type='button' className='btn btn-sm btn-light me-2' onClick={() => onAudit(rule)}>
          История
        </button>
        <button
          type='button'
          className='btn btn-sm btn-light-danger'
          disabled={locked}
          onClick={() => onDelete(rule)}
        >
          Удалить
        </button>
      </td>
    </tr>
  )
}

export default CommissionRulesRow
